import { render, staticRenderFns } from "./WeaponSlot.vue?vue&type=template&id=ab7ffad4&"
import script from "./WeaponSlot.vue?vue&type=script&lang=js&"
export * from "./WeaponSlot.vue?vue&type=script&lang=js&"
import style0 from "./WeaponSlot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports